import React from 'react';
import './SignInModalForm.css';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import SignInBody from './SignInBody';

class SignInModalForm extends React.PureComponent {
    render() {
        const { toggle, modal, redirectToSignUp, redirectToForgotPassword } = this.props;
        return (
            <Modal isOpen={modal} toggle={toggle} className={'sign-in-modal-form'}>
                <ModalHeader toggle={toggle}>Sign-In</ModalHeader>
                <ModalBody>
                    <SignInBody
                        toggle={toggle}
                        redirectToSignUp={redirectToSignUp}
                        redirectToForgotPassword={redirectToForgotPassword}
                    />
                </ModalBody>
            </Modal>
        );
    }
}

export default SignInModalForm;
